import merge from 'lodash/merge';
import toastr from 'toastr';

window.toastr = toastr;

merge(toastr.options, {
	positionClass: 'toast-bottom-right',
	closeButton: true,
	closeHtml: '<button><svg class="icon-svg"><use xlink:href="' + (BX.message.SITE_DIR || '/') + 'include/sprite.svg#cross"></use></svg></button>',
	// timeOut : 0,
	// extendedTimeOut  : 0,
});
